import { defineStore } from 'pinia';

import { homeTranslations } from '@js/i18n/home.js';

import floor1 from '@img/floors/1.webp';
import floor2 from '@img/floors/2.webp';
import floor3 from '@img/floors/3.webp';

const galleryImage = (folder, file, group, alt) => ({
    src: `/assets/images/gallery/${folder}/${file}.webp`,
    alt,
    group,
});

export const useHomeStore = defineStore('homeStore', {
    state: () => ({
        whatsappPhone: '995595156424',
        telegramUsername: 'AniSimnn',

        mapLink: 'https://yandex.com.ge/maps/-/CPgGV29g',

        floorImages: [
            floor1,
            floor2,
            floor3,
        ],

        galleryImages: [
            galleryImage('outdoor', 1, 'street', 'Batumi Center House outdoor'),
            galleryImage('outdoor', 2, 'street', 'Batumi Center House outdoor'),
            galleryImage('outdoor', 3, 'street', 'Batumi Center House outdoor'),
            galleryImage('outdoor', 4, 'street', 'Batumi Center House outdoor'),
            galleryImage('outdoor', 5, 'street', 'Batumi Center House outdoor'),
            galleryImage('outdoor', 6, 'street', 'Batumi Center House outdoor'),

            galleryImage('first_floor', 1, 'floor_1', 'Batumi Center House first floor'),
            galleryImage('first_floor', 2, 'floor_1', 'Batumi Center House first floor'),
            galleryImage('first_floor', 3, 'floor_1', 'Batumi Center House first floor'),
            galleryImage('first_floor', 4, 'floor_1', 'Batumi Center House first floor'),

            galleryImage('second_floor', 1, 'floor_2', 'Batumi Center House second floor'),
            galleryImage('second_floor', 2, 'floor_2', 'Batumi Center House second floor'),
            galleryImage('second_floor', 3, 'floor_2', 'Batumi Center House second floor'),
            galleryImage('second_floor', 4, 'floor_2', 'Batumi Center House second floor'),
            galleryImage('second_floor', 5, 'floor_2', 'Batumi Center House second floor'),
            galleryImage('second_floor', 6, 'floor_2', 'Batumi Center House second floor'),

            galleryImage('third_floor', 1, 'floor_3', 'Batumi Center House third floor'),
            galleryImage('third_floor', 2, 'floor_3', 'Batumi Center House third floor'),
            galleryImage('third_floor', 3, 'floor_3', 'Batumi Center House third floor'),

            galleryImage('window', 1, 'window', 'Batumi Center House third floor'),
            galleryImage('window', 2, 'window', 'Batumi Center House third floor'),
        ],
    }),

    getters: {
        getLocale: () => {
            return (page) => page?.props?.locale || 'ru';
        },

        getLocales: () => {
            return (page) => page?.props?.locales || ['en', 'ka', 'ru'];
        },

        getTranslations: () => {
            return (locale) => homeTranslations[locale] || homeTranslations.ru;
        },

        whatsappLink(state) {
            return `https://wa.me/${state.whatsappPhone}`;
        },

        telegramLink(state) {
            return `https://t.me/${state.telegramUsername}`;
        },

        getStats: () => {
            return (t) => [
                {
                    value: '$295,000',
                    label: t.hero.priceLabel,
                },
                {
                    value: t.hero.area,
                    label: t.hero.areaLabel,
                },
                {
                    value: 3,
                    label: t.hero.floorsLabel,
                },
            ];
        },

        getTabs: () => {
            return (t) => [
                {
                    key: 'all',
                    title: t.gallery.tabs.all,
                },
                {
                    key: 'floor_1',
                    title: t.gallery.tabs.floor_1,
                },
                {
                    key: 'floor_2',
                    title: t.gallery.tabs.floor_2,
                },
                {
                    key: 'floor_3',
                    title: t.gallery.tabs.floor_3,
                },
                {
                    key: 'street',
                    title: t.gallery.tabs.street,
                },
                {
                    key: 'window',
                    title: t.gallery.tabs.window,
                },
            ];
        },

        getDetailsWithFloorImages(state) {
            return (t) => ({
                ...t,
                details: {
                    ...t.details,
                    planning: {
                        ...t.details.planning,
                        floors: t.details.planning.floors.map((floor, index) => ({
                            ...floor,
                            image: state.floorImages[index],
                        })),
                    },
                },
            });
        },
    },
});
